import { concat } from '@ember/helper';
import { htmlSafe, type SafeString } from '@ember/template';
import Component from '@glimmer/component';
import { or } from 'ember-truth-helpers';

import type { TooltipOptions } from '../../../../types/components/prism/data-bar.ts';
import {
  COLOR_TEXT_DEFAULT,
  getCssVariableValue,
} from '../../../../utils/css-variable.ts';
import PrismIcon from '../../icon.gts';
import PrismTooltip from '../../tooltip.gts';

interface PrismDataBarBlocksDataBarValueSignature {
  Args: {
    color?: string;
    showBottomValues?: boolean;
    text?: string;
    tooltip?: TooltipOptions;
    valueItems?: {
      isHidden?: boolean;
      style: SafeString;
      widthPercentage?: number;
    }[];
  };
  Blocks: {
    default: [];
  };
}

export default class PrismDataBarBlocksDataBarValue extends Component<PrismDataBarBlocksDataBarValueSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get colorStyle() {
    const valueColor =
      this.args.color ?? getCssVariableValue(COLOR_TEXT_DEFAULT);
    return htmlSafe(`color: ${valueColor}`);
  }

  <template>
    {{#if (has-block)}}
      <div class={{unless @showBottomValues "data-bar-top-value"}}>
        {{yield}}
      </div>
    {{else}}
      {{#if @showBottomValues}}
        <div class="data-value-content">
          {{#each @valueItems as |valueItem|}}
            <p class="data-value text-200--regular" style={{valueItem.style}}>
              {{#unless valueItem.isHidden}}
                {{concat valueItem.widthPercentage "%"}}
              {{/unless}}
            </p>
          {{/each}}
        </div>
      {{else}}
        <div class="data-bar-value text-200--regular" style={{this.colorStyle}}>
          {{@text}}
          {{#if @tooltip.message}}
            <div>
              <PrismIcon
                @color={{@tooltip.color}}
                @name={{or @tooltip.icon "circle-information-outline"}}
                @size={{or @tooltip.iconSize "small"}}
              />
              <PrismTooltip
                @side={{@tooltip.side}}
                @text={{@tooltip.message}}
                @title={{@tooltip.title}}
              />
            </div>
          {{/if}}
        </div>
      {{/if}}
    {{/if}}
  </template>
}
